/**
 * DD Conditions Tour
 *
 * Tutorial for the DD category editor: question types, answer options,
 * document linking, and condition building. Every step is anchored.
 */

import { TourDefinition } from '../config/tourSteps';

export const ddConditionsTour: TourDefinition = {
  id: 'ddConditionsTour',
  steps: [
    {
      element: '[data-tour="dd-editor-tabs"]',
      popover: {
        title: 'Categorie Editor',
        description:
          'Bewerk hier de basisinformatie, vragen en een overzicht van deze DD-categorie via de tabbladen.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="dd-questions-tab"]',
      popover: {
        title: 'Vragen',
        description:
          'Elke categorie bevat vragen. Per vraag kiest u een type, definieert u antwoordopties en koppelt u eventueel documenten.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: '[data-tour="dd-question-card"]',
      popover: {
        title: 'Vraagkaart',
        description:
          'Klik op een vraag om de details te zien. U kunt de naam, hulptekst, type en antwoordopties aanpassen. Gebruik de pijlen om de volgorde te wijzigen.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="dd-answer-type-selector"]',
      popover: {
        title: 'Vraagtype',
        description:
          'Kies het type: "Status vraag" toont een kleurbolletje. "Selectie" is zonder bolletje. "Document aanwezig" controleert of een bestand bestaat. "Extractie" haalt een waarde uit documenten.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="dd-answer-options"]',
      popover: {
        title: 'Antwoordopties',
        description:
          'Definieer de mogelijke antwoorden. Geef elke optie een label (bijv. "Ja", "Nee"), een statuskeur (groen/oranje/rood) en optioneel een tooltip.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: '[data-tour="dd-file-label-link"]',
      popover: {
        title: 'Document Koppeling',
        description:
          'Koppel bestandslabels aan deze vraag. Het systeem analyseert dan automatisch geüploade documenten met dat label om de vraag te beantwoorden.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: '[data-tour="dd-conditions-builder"]',
      popover: {
        title: 'Conditie Bouwer',
        description:
          'Stel condities in per antwoordoptie. Alle condities moeten waar zijn (AND-logica) voordat het antwoord automatisch wordt geselecteerd. Beschikbare types: bestand bestaat, vervaldatum, veldwaarde, AI-vraag, AI-referentie, database vergelijking, en vraag-antwoord.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: '[data-tour="dd-editor-save"]',
      popover: {
        title: 'Opslaan',
        description:
          'Sla de categorie op. Alle wijzigingen aan vragen, opties en condities worden pas actief na het opslaan.',
        side: 'bottom',
        align: 'end',
      },
    },
  ],
};
